export default __webpack_public_path__ + "static/media/exterior6.7d35b346.webp";